import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { buttonLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy button envelope.
 *
 * `type: z.literal('zero')` is required here (no `.optional()`): a button
 * created inside a zero block must carry the tag end-to-end so that
 * downstream consumers (positioning hosts, render branches) can recognise
 * the placement. The host-app factory copies `meta.type` onto the entity at
 * creation time; missing-tag entities are validation errors against this
 * branch by design.
 *
 * Inner data uses {@link buttonLegacyZeroDataSchema} — the extended-position
 * grid instead of the default variant's simple per-device grid.
 */
export const buttonLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('button'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: buttonLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
